import React from "react";
import { Button, message, theme } from "antd";
import {
    BgColorsOutlined,
    DeleteOutlined,
    ShareAltOutlined,
    DownloadOutlined,
} from "@ant-design/icons";
import { COST_REDESIGN } from "../../constants";

function MobileCanvasActionBar({
    tokenData,
    setOpenTokenModal,
    setCurrentAction,
    reduceToken,
    share,
    download,
    status,
    onDelete,
}) {
    const { token } = theme.useToken();

    function handleRedesign() {
        if (tokenData?.[0]?.count < COST_REDESIGN) {
            message.error("Insufficient tokens");
            setOpenTokenModal(true);
            return;
        }
        setCurrentAction({ id: "redesign" });
        reduceToken.mutate({ amount: COST_REDESIGN });
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 10px",
                gap: 8,
                borderBottom: `1px solid ${token.colorBorderSecondary}`,
                backgroundColor: token.colorBgContainer,
            }}
        >
            <div style={{ display: "flex", gap: 8 }}>
                <Button icon={<BgColorsOutlined />} onClick={handleRedesign}>
                    Redesign
                </Button>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
                {onDelete && (
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={onDelete}
                    ></Button>
                )}
                <Button
                    icon={<DownloadOutlined />}
                    onClick={download}
                    loading={status?.download}
                    type="primary"
                    // style={{ height: 40 }}
                ></Button>
                <Button
                    icon={<ShareAltOutlined />}
                    onClick={share}
                    loading={status?.share}
                    type="primary"
                    // style={{ height: 40 }}
                >
                    Share
                </Button>
            </div>
        </div>
    );
}

export default MobileCanvasActionBar;
